export default "__VITE_ASSET__CJyhDz4n__"